import React from 'react';
import { withStyles } from '@material-ui/core';
import DataGrid from '@dataGrid';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import StatusBar from '@dataGrid/components/StatusBar';
import styles from '../styles';
import { withAppConfig } from '../../../../../../appConfigContext';
class Grid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridApi: this.createGridConfig(props)
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tabId !== this.props.tabId) {
      this.setState({ gridApi: this.createGridConfig(this.props) });
    }
  }

  createGridConfig(props) {
    return new props.gridConfig({
      name: props.tabConfig[props.tabId].gridName,
      ...(props.tabId === 0
        ? {
            terminalAccessLabel: props.configJSON.terminalAccessLabel,
            columnConfig: props.configJSON?.gridColumnConfig
          }
        : {})
    });
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.props.setGridApi && this.props.setGridApi(api);
  };

  onSelectionChanged = () => {
    if (this.props.dataSelectedOnGrid && this.gridApi) {
      const rowIdKey = this.props.tabConfig[this.props.tabId].getApiCode;
      const selectedRows = this.gridApi.getSelectedRows().map((row) => row[rowIdKey]);
      this.props.dataSelectedOnGrid(selectedRows);
    }
  };

  updateSelection = () => {
    if (this.gridApi && this.gridApi.getDisplayedRowCount()) {
      const rowIdKey = this.props.tabConfig[this.props.tabId].getApiCode;
      this.gridApi.forEachNode((node) => {
        if (this.props.selectedData?.includes(node.data[rowIdKey])) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true, false, true);
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: 'selectionChanged',
        api: this.gridApi
      });
    }
  };

  render() {
    const dataList = this.props.dataList?.slice() || [];
    const rowIdKey = this.props.tabConfig[this.props.tabId].gridKey;
    const gridName = this.props.tabConfig[this.props.tabId].gridName;
    return (
      <div className={this.props.classes.dataGrid} key={this.props.tabId}>
        <DataGrid
          key={this.props.tabId}
          defaultColDef={this.state.gridApi.config.defaultColDef}
          columnDefs={this.state.gridApi.config.columns}
          config={this.state.gridApi.config}
          rowSelection={this.state.gridApi.config.rowSelection}
          rowDeselection={this.state.gridApi.config.rowDeselection}
          enableFilter={this.state.gridApi.config.enableFilter}
          enableSorting={this.state.gridApi.config.enableSorting}
          rowData={dataList}
          deltaRowDataMode={true}
          getRowId={(params) => params.data[rowIdKey]}
          onGridReady={this.onGridReady}
          animateRows={false}
          onRowDataUpdated={this.updateSelection}
          onSelectionChanged={this.onSelectionChanged}
          quickFilterText={this.props.searchText}
          panelLabel={(filteredData) => (
            <StatusBar
              data={[
                {
                  label: `${filteredData.length} ${gridName}`
                }
              ]}
            />
          )}
          showErrorMessage={this.props.showErrorMessage}
        />
      </div>
    );
  }
}

export default compose(withStyles(styles), withSnackbar, withAppConfig)(Grid);
